package model

//import views.componentes.textSelect
import utils.*

//import utils.ffVss

open class Inotas {

    var INOT_EMPRESA = 0
    var INOT_OF = 0
    var INOT_PROD = 0
    var INOT_GRADE = 0
    var INOT_NRPED = ""
    var INOT_QTD = 0.0
    var INOT_VLUNIT = 0.0
    var INOT_TPENTR = 0
    var INOT_CST = ""
    var INOT_TOTAL = 0.0
    var INOT_ICMS = 0.0
    var INOT_UNID = ""
    var INOT_DECRETO = ""
    var INOT_DESCPROD = ""
    var INOT_VLDESC = 0.0
    var INOT_IDESC = 0.0
    var INOT_DESCRPA = 0.0
    var INOT_IVA = 0.0
    var INOT_REDBASE = 0.0
    var INOT_BASEICM = 0.0
    var INOT_CFOP = ""
    var INOT_CFOPDESCR = ""
    var INOT_PERCOMIS = 0.0
    var INOT_PRECOBASE = 0.0
    var INOT_VERBATIPO = ""
    var INOT_GTIN = ""
    var INOT_NCM = ""
    var INOT_GENERO = ""
    var INOT_BCST = 0.0
    var INOT_ICMSST = 0.0
    var INOT_VLICMS = 0.0
    var INOT_COFINSPER = 0.0
    var INOT_PISPER = 0.0
    var INOT_IPIPER = 0.0
    var INOT_IPIVL = 0.0
    var INOT_IPIVLUNIT = 0.0
    var INOT_PPAUTA = 0.0
    var INOT_CUSTOM = 0.0
    var INOT_ICMSIVA = 0.0
    var INOT_FRETEVL = 0.0
    var INOT_PISBASE = 0.0
    var INOT_CUSTOU = 0.0
    var INOT_DESCADICIONAL = ""
    var INOT_CUSTOL = 0.0
    var INOT_SERIE = 0
    var INOT_PROLOTID = ""
    var INOT_VALIDADE = ff.InicialDate
    var INOT_VLUNITBRUTO = 0.0
    var INOT_PCREDSN = 0.0
    var INOT_CSOSN = ""
    var INOT_VCREDICMSSN = 0.0
    var INOT_GTINEMB = ""
    var INOT_SEGUROVL = 0.0
    var INOT_MODICMSST = ""
    var INOT_MODICMS = ""
    var INOT_SITPIS = ""
    var INOT_SITCOFINS = ""
    var INOT_SITIPI = ""
    var INOT_VLACESSO = 0.0
    var INOT_CUSTOANT = 0.0
    var INOT_CUSMEDANT = 0.0
    var INOT_ACRES = 0.0
    var INOT_VLREDUCAO = 0.0
    var INOT_CLIENTE = 0
    var INOT_ORDEM = 0
    var INOT_ITEORDEM = 0
    var INOT_COFINSU = 0.0
    var INOT_PISU = 0.0
    var INOT_PROCODIGO = 0
    var INOT_PISNATREC = ""
    var INOT_CFOPENT = ""
    var INOT_NTREL = 0
    var INOT_OFREL = 0
    var INOT_AJUSTEVL = 0.0
    var INOT_AJUSTEBS = 0.0
    var INOT_AJUSTETP = ""
    var INOT_GNRERECO = ""
    var INOT_REDTIPO = ""
    var INOT_FCINR = ""
    var INOT_CSTORIGEM = ""
    var INOT_CSTITEM = ""
    var INOT_IMPTRANSPER = 0.0
    var INOT_TOTNOTA = 0.0
    var INOT_FATORFISCAL = 0.0
    var INOT_FATORFISICO = 0.0
    var INOT_ESTCONTROLE = 0
    var INOT_ESTCONTROLEENT = 0
    var INOT_VICMSDESON = 0.0
    var INOT_QTDCONT = 0.0
    var INOT_DESCRANT = ""
    var INOT_BACKUP = ""
    var inot_bkppis = 0.0
    var inot_bkpcofins = 0.0
    var inot_bkppisnatrec = ""
    var INOT_IPIENQ = ""
    var INOT_VLICMSC = 0.0
    var INOT_PISPERC = 0.0
    var INOT_COFINSPERC = 0.0
    var INOT_XMLINF = ""
    var INOT_CEST = ""
    var INOT_PICMSINTRA = 0.0
    var INOT_PFCPUFDEST = 0.0
    var INOT_PICMSINTERPART = 0.0
    var INOT_DTEMI = ff.InicialDate
    var INOT_DTTERM = ff.InicialDate
    var INOT_LOTEXML = ff.InicialDate
    var INOT_INDPROITIPO = ""
    var INOT_MATPRIMA = ""

    var ITOTAL = 0.0

    //outros campos
    var EST_QTRESOF00  = 0.0
    var INOT_PRODSEL00 = 0

    class InotasResu {
        var INOT_EMPRESA = 0
        var INOT_OF = 0
        var INOT_ORDEM = 0
        var INOT_ITEORDEM = 0
        var INOT_PROD = 0
        var INOT_DESCPROD = ""
        var INOT_GRADE = 0
        var INOT_NRPED = ""
        var INOT_QTD = 0.0
        var INOT_VLUNIT = 0.0
        var INOT_TOTAL = 0.0
        var INOT_TOTNOTA = 0.0
        var INOT_QTDCONT = 0.0
        var INOT_IVA = 0.0
        var INOT_GTIN = ""
        var INOT_GTINEMB = ""
        var INOT_NCM = ""
        var INOT_DTEMI = ff.InicialDate
        var INOT_DTVIG = ff.InicialDate
        var INOT_LOTEXML = ""
        var INOT_PROLOTID = 0
        var INOT_FATORFISICO = 0
        var INOT_FATORFISCAL = 0
        var INOT_ESTCONTROLE = 0
        var INOT_INDPROITIPO = ""
        var INOT_MATPRIMA = ""

        var INOT_OBS00 = ""
        var NOT_CHAVEACESSO00 = ""
        var NOT_NOTATIPO00 = ""
        var NOT_CLIENTE00 = 0
        var CLI_NOME00 = ""
        var TPNT_DESCR00 = ""
        var PROLOT_LOTEFAB = ""
        var PROLOT_DTVAL = ff.InicialDate
        var PROLOT_ID = 0
        var PROLOT_OBS = ""
        var PROLOT_QTDEMB = 0
        var PROLOT_QUARENTENA = ""

        var PRO_MEDIDA = ""
        var PRO_UNIDMED = ""
        var PRO_QTEMB = 0.0
        var PRO_CXEMBARQUE = 0.0
        var PRO_UNID = ""
        var PRO_PALETQTD = 0
        var PRO_PESOLIQ = 0.0
        var PRO_PESOBRUTO = 0.0
        var PRO_REFER = ""
        var PRO_FABR = 0
        var FABR_DESCR = ""
        var PRO_ARM = ""
        var ARM_DESCR = ""
        var EST_BARRAOFICIAL = ""
        var ESTG_EAN = ""
        var ESTG_TIPO = ""
        var ESTG_UNIDVENDA = 0.0
        var ESTG_EANC = ""
        var ESTG_EAND = ""
        var ESTG_EANU = ""
        var EST_CONTRLOTE = ""
        var EST_DIASVALID = 0
        var EST_DIASVALIDMIN = 0
        var EST_LOCAL00 = ""
        var EST_OBRBARRALOTE = "N"

        var OO_DESCRCOMPLETA = ""
        var OO_USUSEPA = ""
        var OO_QTDFALTA = ""
        var OO_FALTASN = "OLA"
        var OO_DESCPROD = ""
        var OO_BARRAS = ""
        var OO_CORLINHA = ""
        var OO_COLUMN1 = ""

        fun construtorLista(_it: String): List<InotasResu> {

            val lObj = ArrayList<InotasResu>()
            try {
                val it = if (_it.ffCopy(1, 1).equals("[")) _it else "[$_it]"

                if ((!it.equals(null)) && (!it.equals(""))) {
                    val lista = JSON.parse<Array<dynamic>>(it)

                    lista.forEach {
                        val o = InotasResu()
                        o.INOT_EMPRESA = it.INOT_EMPRESA.toString().ffVsi()
                        o.INOT_OF = it.INOT_OF.toString().ffVsi()
                        o.INOT_ORDEM = it.INOT_ORDEM.toString().ffVsi()
                        o.INOT_ITEORDEM = it.INOT_ITEORDEM.toString().ffVsi()
                        o.INOT_PROD = it.INOT_PROD.toString().ffVsi()
                        o.INOT_DESCPROD = it.INOT_DESCPROD.toString().ffVss()
                        o.INOT_GRADE = it.INOT_GRADE.toString().ffVsi()
                        o.INOT_NRPED = it.INOT_NRPED.toString().ffVss()
                        o.INOT_QTD = it.INOT_QTD.toString().ffVsdo()
                        o.INOT_QTDCONT = it.INOT_QTDCONT.toString().ffVsdo()
                        o.INOT_VLUNIT = it.INOT_VLUNIT.toString().ffVsdo()
                        o.INOT_TOTAL = it.INOT_TOTAL.toString().ffVsdo()
                        o.INOT_IVA = it.INOT_IVA.toString().ffVsdo()
                        o.INOT_GTIN = it.INOT_GTIN.toString().ffVss()
                        o.INOT_GTINEMB = it.INOT_GTINEMB.toString().ffVss()
                        o.INOT_NCM = it.INOT_NCM.toString().ffVss()
                        o.INOT_DTEMI = it.INOT_DTEMI.toString().ffDsd()
                        o.INOT_DTVIG = it.INOT_DTVIG.toString().ffDsd()
                        o.INOT_LOTEXML = it.INOT_LOTEXML.toString().ffVss()
                        o.INOT_PROLOTID = it.INOT_PROLOTID.toString().ffVsi()
                        o.INOT_FATORFISICO = it.INOT_FATORFISICO.toString().ffVsi()
                        o.INOT_FATORFISCAL = it.INOT_FATORFISCAL.toString().ffVsi()
                        o.INOT_ESTCONTROLE = it.INOT_ESTCONTROLE.toString().ffVsi()
                        o.INOT_INDPROITIPO = it.INOT_INDPROITIPO.toString().ffVss()
                        o.INOT_MATPRIMA = it.INOT_MATPRIMA.toString().ffVss()

                        o.INOT_OBS00 = it.INOT_OBS00.toString().ffVss()
                        o.NOT_CHAVEACESSO00 = it.NOT_CHAVEACESSO00.toString().ffVss()
                        o.NOT_NOTATIPO00 = it.NOT_NOTATIPO00.toString().ffVss()
                        o.NOT_CLIENTE00 = it.NOT_CLIENTE00.toString().ffVsi()
                        o.CLI_NOME00 = it.CLI_NOME00.toString().ffVss()
                        o.TPNT_DESCR00 = it.TPNT_DESCR00.toString().ffVss()

                        o.PROLOT_ID = it.PROLOT_ID.toString().ffVsi()
                        o.PROLOT_LOTEFAB = it.PROLOT_LOTEFAB.toString().ffVss()
                        o.PROLOT_DTVAL = it.PROLOT_DTVAL.toString().ffDsd()
                        o.PROLOT_OBS = it.PROLOT_OBS.toString().ffVss()
                        o.PROLOT_QTDEMB = it.PROLOT_QTDEMB.toString().ffVsi()
                        o.PROLOT_QUARENTENA = it.PROLOT_QUARENTENA.toString().ffVss()
                          //PROLOT_QUARENTENA = it.PROLOT_QUARENTENTA.toString().ffVss()

                        o.PRO_MEDIDA = it.PRO_MEDIDA.toString().ffVss()
                        o.PRO_UNIDMED = it.PRO_UNIDMED.toString().ffVss()
                        o.PRO_QTEMB = it.PRO_QTEMB.toString().ffVsdo()
                        o.PRO_CXEMBARQUE = it.PRO_CXEMBARQUE.toString().ffVsdo()
                        o.PRO_UNID = it.PRO_UNID.toString().ffVss()
                        o.PRO_PALETQTD = it.PRO_PALETQTD.toString().ffVsi()
                        o.PRO_PESOLIQ = it.PRO_PESOLIQ.toString().ffVsdo()
                        o.PRO_PESOBRUTO = it.PRO_PESOBRUTO.toString().ffVsdo()
                        o.PRO_REFER = it.PRO_REFER.toString().ffVss()
                        o.PRO_FABR = it.PRO_FABR.toString().ffVsi()
                        o.FABR_DESCR = it.FABR_DESCR.toString().ffVss()
                        o.PRO_ARM = it.PRO_ARM.toString().ffVss()
                        o.ARM_DESCR = it.ARM_DESCR.toString().ffVss()
                        o.OO_DESCRCOMPLETA = it.OO_DESCRCOMPLETA.toString().ffVss()
                        o.EST_BARRAOFICIAL = it.EST_BARRAOFICIAL.toString().ffVss()
                        o.ESTG_EAN = it.ESTG_EAN.toString().ffVss()
                        o.ESTG_TIPO = it.ESTG_TIPO.toString().ffVss()
                        o.ESTG_UNIDVENDA = it.ESTG_UNIDVENDA.toString().ffVsdo()
                        o.ESTG_EANC = it.ESTG_EANC.toString().ffVss()
                        o.ESTG_EAND = it.ESTG_EAND.toString().ffVss()
                        o.ESTG_EANU = it.ESTG_EANU.toString().ffVss()
                        o.EST_CONTRLOTE = it.EST_CONTRLOTE.toString().ffVss()
                        o.EST_DIASVALID = it.EST_DIASVALID.toString().ffVsi()
                        o.EST_DIASVALIDMIN = it.EST_DIASVALIDMIN.toString().ffVsi()
                        o.EST_LOCAL00 = it.EST_LOCAL00.toString().ffVss()
                        o.EST_OBRBARRALOTE = it.EST_OBRBARRALOTE.toString().ffVss()

                        if (o.EST_OBRBARRALOTE.equals(""))
                            o.EST_OBRBARRALOTE = "N"


                        o.OO_QTDFALTA = (o.INOT_QTD - o.INOT_QTDCONT).toString()
                        if (o.PROLOT_QUARENTENA == "S")
                            o.OO_QTDFALTA = "QUARENTENA"
                        o.OO_BARRAS = it.OO_BARRAS.toString().ffVss()


                        if (o.OO_QTDFALTA == "0")
                            o.OO_FALTASN = " ok"
                        else if (o.OO_QTDFALTA.ffVsc() < 0)
                            o.OO_FALTASN = "Sobra"
                        else
                            o.OO_FALTASN = "Falta"

                        lObj.add(o)
                    }
                }
                println(lObj)
                return lObj
            } catch (e: Exception) {
                ff.println0(e.message)
                return lObj
            }
        }

        fun getProdutoOF(_recurso: String, cb: (List<InotasResu>) -> Unit) {

            ff.println0("executando getProdutoOF")

            Service().getString(_recurso) { _sRetorno ->
                //ff.println0("quarentena12 zuza aqui 54")
                //ff.println0(_sRetorno)
                cb(InotasResu().construtorLista(_sRetorno))
            }
        }

    }

}